import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import Header from '../../../../components/ImportDesktopFile/Toast/Header';
import * as selectors from '../selectors';

const mapStateToProps = (state: StoreState) => {
	return {
		filesIds: selectors.getFilesToDisplayIds(state),
		importedFilesNumber: selectors.getImportedFilesNumber(state),
		isFilesWithError: selectors.getFilesWithErrorNumber(state) > 0,
	};
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/Toast/Header/index.tsx